(function() {
    'use strict';
    angular.module('elogbooks.user.meter-manufacturers', []);
})();
